//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const TYPE_OPTS = {
    water: [
        {
            text: '不限',
            value: ''
        },
        {
            text: '50万以下',
            value: '0-500000'
        },
        {
            text: '50-100万',
            value: '500000-1000000'
        },
        {
            text: '100-150万',
            value: '1000000-1500000'
        },
        {
            text: '150-200万',
            value: '1500000-2000000'
        },
        {
            text: '200-250万',
            value: '2000000-2500000'
        },
        {
            text: '250-300万',
            value: '2500000-3000000'
        }
    ],
    square: [
        {
            text: '不限',
            value: ''
        },
        {
            text: '6000元/㎡以下',
            value: '0-6000'
        },
        {
            text: '6000元-8000元/㎡',
            value: '6000-8000'
        },
        {
            text: '8000元-10000元/㎡',
            value: '8000-10000'
        },
        {
            text: '10000元-15000元/㎡',
            value: '10000-15000'
        },
        {
            text: '15000元-20000元/㎡',
            value: '15000-20000'
        },
        {
            text: '20000元-30000元/㎡',
            value: '20000-30000'
        }
    ]
}

const getInit = () => {
    return {
        selected: '',
        selected_tx: '不限',
        tabs: [
            {
                text: '总价',
                value: 'water'
            },
            {
                text: '单价',
                value: 'square'
            }
        ],
        type: 'water',
        start: '',
        end: ''
    }
}

export default {
    data () {
        return getInit()
    },
    onUnload () {
        this.type = 'water'
        this.start = ''
        this.end = ''
        this.selected = ''
    },
    computed: {
        opts () {
            return TYPE_OPTS[this.type]
        },
        input_tip_start () {
            return this.type === 'water' ? '最低总价' : '最低单价'
        },
        input_tip_end () {
            return this.type === 'water' ? '最高总价' : '最高单价'
        }
    },
    methods: {
        changeType (e) {
            this.type = e.currentTarget.dataset.type
            this.start = ''
            this.end = ''
        },
        onSelect (e) {
            this.selected = e.currentTarget.dataset.value
            this.selected_tx = e.currentTarget.dataset.text
        },
        changeStart (e) {
            this.start = e.target.value
        },
        changeEnd (e) {
            this.end = e.target.value
        },
        confirm () {
            let { start, end, selected_tx } = this
            if (this.start && this.end) {
                if (this.type === 'water') {
                    selected_tx = `${start}万-${end}万`
                    start *= 10000
                    end *= 10000
                } else {
                    selected_tx = `${start}元-${end}元/㎡`
                }
                this.selected_tx = selected_tx
            }
            if (this.type === 'water' && this.start && this.end) {
                start *= 10000
                end *= 10000
            }
            const price = start != '' && end !='' ? `${start}-${end}` : this.selected
            if (!price && (start || end)) {
                this.$wx.showToast({
                    title: '请选择或填写价格',
                    icon: 'none'
                })
                return
            }
            this.$emit('change', this.type, price, selected_tx)
        }
    },
    props: {
        show: {
            type: Boolean
        }
    }
}
